module.exports = __webpack_public_path__ + "static/img/warn.3879fa91.png";